import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { fetchMarketIntelligence } from '../api';

export function useMarketIntelligence() {
  return useGrowthQuery({
    queryKey: growthKeys.market(),
    queryFn: fetchMarketIntelligence,
  });
}
